import { render, staticRenderFns } from "./RegisterClient.vue?vue&type=template&id=a7d251f6&"
import script from "./RegisterClient.js?vue&type=script&lang=js&"
export * from "./RegisterClient.js?vue&type=script&lang=js&"
import style0 from "./RegisterClient.vue?vue&type=style&index=0&id=a7d251f6&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports